import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import FAQ from './pages/FAQ';
import Services from './pages/Services';
import MentalCapacity from './pages/Services/MentalCapacity';
import TraumaPTSD from './pages/Services/TraumaPTSD';
import Specialist from './pages/Services/Specialist';
import Privacy from './pages/Policies/Privacy';
import Terms from './pages/Policies/Terms';
import Cancellation from './pages/Policies/Cancellation';
import ForensicRisk from './pages/Services/ForensicRisk';
import Neurodevelopmental from './pages/Services/Neurodevelopmental';
// ScrollToTop component to ensure page loads at the top
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
export function AppRouter() {
  return <BrowserRouter data-id="element-1">
      <Helmet data-id="element-2">
        <title data-id="element-3">
          Medicolegal Psychiatry – Expert Witness Psychiatric Services UK
        </title>
        <meta name="description" content="Dr. Imtiaz Syed provides expert psychiatric assessments and reports for legal proceedings. Trusted by solicitors, barristers and courts across the UK." data-id="element-4" />
        <link rel="preconnect" href="https://fonts.googleapis.com" data-id="element-5" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="" data-id="element-6" />
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Merriweather:wght@400;700&display=swap" rel="stylesheet" data-id="element-7" />
        <link rel="icon" href="https://uploadthingy.s3.us-west-1.amazonaws.com/hDXV1rDXM1m2ARqkQ9Hg8F/Medico_Favicon.png" type="image/png" data-id="element-8" />
      </Helmet>
      <div className="flex flex-col min-h-screen" data-id="element-9">
        <Header data-id="element-10" />
        <ScrollToTop data-id="element-11" />
        <div className="flex-grow" data-id="element-12">
          <Routes data-id="element-13">
            <Route path="/" element={<Home data-id="element-15" />} data-id="element-14" />
            <Route path="/about" element={<About data-id="element-17" />} data-id="element-16" />
            <Route path="/services" element={<Services data-id="element-19" />} data-id="element-18" />
            <Route path="/services/mental-capacity" element={<MentalCapacity data-id="element-21" />} data-id="element-20" />
            <Route path="/services/trauma-ptsd" element={<TraumaPTSD data-id="element-23" />} data-id="element-22" />
            <Route path="/services/specialist" element={<Specialist data-id="element-25" />} data-id="element-24" />
            <Route path="/services/forensic-risk" element={<ForensicRisk data-id="element-27" />} data-id="element-26" />
            <Route path="/services/neurodevelopmental" element={<Neurodevelopmental data-id="element-29" />} data-id="element-28" />
            <Route path="/faq" element={<FAQ data-id="element-31" />} data-id="element-30" />
            <Route path="/contact" element={<Contact data-id="element-33" />} data-id="element-32" />
            <Route path="/policies/privacy" element={<Privacy data-id="element-35" />} data-id="element-34" />
            <Route path="/policies/terms" element={<Terms data-id="element-37" />} data-id="element-36" />
            <Route path="/policies/cancellation" element={<Cancellation data-id="element-39" />} data-id="element-38" />
          </Routes>
        </div>
        <Footer data-id="element-40" />
      </div>
    </BrowserRouter>;
}